import { ReactElement, useCallback, useEffect } from 'react';

import { useParams } from 'react-router-dom';

import GratiPageWrapper from '../components/common/GratiPageWrapper';
import DivisionEditor from '../components/division/DivisionEditor';
import { useApp } from '../contextProviders/AppProvider';
import { useData } from '../contextProviders/DataProvider';
import useDivision from '../dataHooks/useDivision';
import { useLeagueDivisionMutator } from '../dataMutators/useLeagueDivisionMutator';
import Grouping from '../types/Grouping';
import Person from '../types/Person';

export default function DivisionEditPage(): ReactElement {
  const { orgId, leagueId, divisionId } = useParams();
  const { setPageName } = useApp();
  const { isLeagueAdmin } = useData();
  const { updateDivision } = useLeagueDivisionMutator();

  const { division, isDivisionLoading, divisionError } = useDivision({ orgId, divisionId });

  useEffect(() => {
    setPageName('Edit division');
  }, [setPageName]);

  const handleUpdate = useCallback(async (changes: Partial<Grouping>) => {
    if (!orgId) return;
    await updateDivision(orgId, changes);
  }, [orgId, updateDivision]);

  const validateUser = (userProfile: Person | null | undefined) => {
    return !!(userProfile && leagueId && isLeagueAdmin(leagueId, orgId ?? ''));
  };

  return (
    <GratiPageWrapper
      validateUser={validateUser}
      isContentLoading={isDivisionLoading && !division}
      contentError={divisionError}
    >
      {division && (
        <DivisionEditor division={division} updateDivision={handleUpdate} />
      )}
    </GratiPageWrapper>
  );
}
